import React from 'react'
import { type SurveyCompletionRate } from '../../models/Division'
import { SectionTableFeature } from './components/SectionTable'
import { TopLevelSurveyResult } from './components/TopLevelSurveyResult'
import SurveyReportItems from './components/SurveyReportItems'
import { type ReportsV2 } from '../../models/Report'

export interface ReportsFeatureProps {
  completionRate: SurveyCompletionRate
  reports: ReportsV2
  reportError: Record<string, any> | null
  currentBreadCrumbElementIndex?: number | undefined
  parentSurveyScore?: number | null

}

const ReportsFeature: React.FC<ReportsFeatureProps> = ({ completionRate, reports, reportError, parentSurveyScore }): JSX.Element => {
  return (
    <>
      <SectionTableFeature completionRate={completionRate} parentSurveyScore={parentSurveyScore} />
      <TopLevelSurveyResult calculations={reports?.calculations} titles={reports?.titles} />
      <SurveyReportItems
        reports={reports}
        completionRate={completionRate}
        reportError={reportError}
      />
    </>

  )
}

export default ReportsFeature
